import { appConfig } from '../../services/config';
import JwtIo from '../../images/jwt-io.png';

function JwtIoButton(props) {
  const jwtIoUrl = props.token ? appConfig.jwtIoUrl + '?access_token=' + props.token : appConfig.jwtIoUrl;
  
  function handleJwtIo(event) {
    event.preventDefault();
    window.open(jwtIoUrl, '_blank');
  }

  return (
    <img className="jwt-io bottom-right spc-r-80 spc-b-8" 
      src={JwtIo} alt='JWT.IO' title="Inspect with JWT.IO" 
      onClick={handleJwtIo} />
  )
}

export default JwtIoButton;
